import { toast, Typography } from "@suraasa/placebo-ui"
import { AuthManager } from "features/Authentication/AuthManager"
import SelectableCard from "features/Onboarding/Components/SelectableCard"
import { getNavigationPortal } from "features/Onboarding/Navigation/utils"
import { FormPageProps } from "features/Onboarding/types"

const options = [
  { label: "Yes", value: true },
  { label: "No", value: false },
]

const CurrentlyTeachingInSchoolStatus = ({
  data,
  updateData,
  onNext,
  ...props
}: FormPageProps) => {
  const auth = AuthManager.getPlatformAuth()
  const name = auth ? auth.user.firstName : ""

  const updateBackend = async (value: boolean) => {
    try {
      await props.apiAdapter.saveIsTeachingInSchool(value)
    } catch (e) {
      console.error("Failed to update backend:", e)
    }
  }

  const handleSelection = async (value: boolean) => {
    updateData({ isTeachingInSchool: value })
  }

  const handleSubmit = async () => {
    if (data.isTeachingInSchool === null) {
      toast.error("Please select an option")
      return
    }
    await updateBackend(data.isTeachingInSchool)
    await onNext()
  }

  const isDisabled = data.isTeachingInSchool === null

  return (
    <div className="flex flex-col items-start">
      <Typography variant="title2">
        {name ? `Hi ${name},` : "Hi,"} are you currently teaching in a school?
      </Typography>
      <div className="mt-4 flex w-full max-w-[480px] flex-col gap-1">
        {options.map(option => (
          <SelectableCard
            key={option.label}
            selected={data.isTeachingInSchool === option.value}
            type="radio"
            onClick={() => handleSelection(option.value)}
          >
            <Typography variant="subtitle2">{option.label}</Typography>
          </SelectableCard>
        ))}
      </div>

      {getNavigationPortal({
        disableNext: isDisabled,
        onNext: handleSubmit,
        ...props,
      })}
    </div>
  )
}

export default CurrentlyTeachingInSchoolStatus
